module.exports = __webpack_public_path__ + "media/images/markers/audio-d79b4e3d809382bcdbda7e364aa6fa21.png";